import React from 'react'
import { Box, Typography } from 'transfix-ui/core'
import { IDocumentListWrapperProps, IBaseFileType } from 'apps/fleet-planner/types'
import { DocumentList, EmptyState } from './DocumentList'

const getDocumentTitle = () => 'Rate Confirmation'

/**
 * Displays Rate Confirmation and Payables
 * from Marketplace's IShipment['documents']
 */
export function DocumentRateConList<T extends IBaseFileType>({
  documents: documentsProp = [],
  getDocumentSubtitle,
  onReplace,
}: IDocumentListWrapperProps<T>) {
  return (
    <Box>
      <Box mb={1}>
        <Typography variant='subtitle2'>Rate Confirmation and Payables</Typography>
      </Box>
      <DocumentList
        fileType='rate_con'
        isEditable={false}
        documentName='Rate Confirmation'
        documents={documentsProp}
        getDocumentTitle={getDocumentTitle}
        getDocumentSubtitle={getDocumentSubtitle}
        onReplace={onReplace}
        limit={1}
        EmptyStateComponent={<EmptyState />}
      />
    </Box>
  )
}
